import {VuexModule, Module, Action, Mutation} from 'vuex-module-decorators';
import api from '@/api';
import i18n from '@/i18n';

@Module
export default class TicketModule extends VuexModule {
    _product_type_groups: any = [];
    _product_type_list: any = [];
    _product_types_map: any = {
        idMap: {},
        nameMap: {},
    };
    _commonProductTypes: any[] = [
        {
            id: '64',
            displayValue: i18n.t('cai-wu-lei'),
            tip: i18n.t('cai-wu-lei-ti-shi'),
        },
        {
            id: '15',
            displayValue: i18n.t('zhang-hao-lei'),
            tip: i18n.t('zhang-hao-lei-ti-shi'),
        },
        {
            id: '16',
            displayValue: i18n.t('bei-an'),
            tip: i18n.t('bei-an-ti-shi'),
        },
        {
            id: '69',
            displayValue: i18n.t('shou-qian-zi-xun'),
            tip: i18n.t('shou-qian-zi-xun-ti-shi'),
        },
    ];

    _withdraw_messages_map: any = {};

    get commonProductTypes() {
        return this._commonProductTypes;
    }

    get productTypeGroups() {
        return this._product_type_groups;
    }

    get productTypeList() {
        return this._product_type_list;
    }

    get productTypesMap() {
        return this._product_types_map;
    }

    get withdrawMessagesMap() {
        return this._withdraw_messages_map;
    }

    @Mutation
    UP_TICKET_TYPE_LIST(ticketTypeList: any) {
        this._product_type_groups = ticketTypeList;

        const productTypeList: any[] = JSON.parse(JSON.stringify(this._commonProductTypes));
        this._product_type_groups.forEach((productTypeGroup: any) => {
            productTypeGroup.children.forEach((productType: any) => {
                productTypeList.push(productType);
            });
        });
        this._product_type_list = productTypeList;

        const nameMap: any = {};
        const idMap: any = {};
        this._product_type_list.forEach((product: any) => {
            nameMap[product.serviceType] = product;
            idMap[product.id] = product;
        });

        this._product_types_map = {
            nameMap,
            idMap,
        };
    }

    @Mutation
    UP_WITHDRAW_MESSAGES_MAP(withdrawMessagesMap: any) {
        this._withdraw_messages_map = withdrawMessagesMap;
    }

    // https://stackoverflow.com/questions/54127423/vuex-module-decorator-modifying-state-inside-an-action
    @Action({rawError: true})
    async GET_TICKET_TYPE_LIST() {
        const res = await api.getTicketQuestionTypeList();
        this.context.commit('UP_TICKET_TYPE_LIST', res.data.result);
    }
}
